import React from "react";

function TeleOnlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 145.235 95.863"
      {...props}
    >
      <g transform="translate(265.385 -81.247)">
        <path
          fill="#0067a2"
          fillOpacity="1"
          strokeWidth="0.265"
          d="M-142.497 172.656l-4.577-4.583 1.6-2.097c4.96-6.503 9.125-14.878 11.012-22.14 4.286-16.494.873-34.618-9.044-48.027-.8-1.081-1.937-2.49-2.528-3.131l-1.075-1.166 4.604-4.61 4.603-4.608.76.722c1.262 1.197 4.242 5.055 6.077 7.865 5.517 8.449 8.747 17.312 10.417 28.595.719 4.852.648 15.107-.14 20.221-1.725 11.199-5.365 20.801-11.332 29.898-1.88 2.867-5.122 7.225-5.588 7.513-.116.072-2.271-1.931-4.789-4.452zm-106.083 2.349c-6.71-7.342-12.289-18.059-14.869-28.561-1.484-6.043-1.92-9.891-1.936-17.066-.008-3.88.124-7.544.33-9.128 1.722-13.217 6.584-25.243 14.426-35.684 1.228-1.635 2.399-3.11 2.602-3.279.297-.246 1.256.584 4.956 4.289l4.589 4.594-.936 1.15c-2.991 3.673-7.092 11.127-9.066 16.48-4.783 12.97-5.053 27.208-.761 40.073 2.099 6.292 5.704 12.842 9.59 17.42.894 1.054 1.625 2.008 1.625 2.12 0 .244-8.795 9.061-9.038 9.061-.093 0-.773-.661-1.512-1.47zm50.767.133c-3.686-.459-6.468-1.072-9.657-2.127-16.085-5.325-27.722-18.734-30.864-35.563-.848-4.545-.848-12.124 0-16.669 3.573-19.137 18.076-33.64 37.214-37.213 4.545-.848 12.124-.848 16.669 0 16.837 3.143 30.203 14.746 35.574 30.882 1.685 5.062 2.213 8.563 2.213 14.666 0 4.152-.112 5.775-.575 8.316-3.467 19.028-18.368 33.919-37.23 37.205-3.618.63-10.294.882-13.344.503zm13.024-34.99c8.255-5.996 14.982-10.982 14.95-11.08-.033-.097-8.037-5.974-17.787-13.06-9.75-7.086-17.876-13.004-18.058-13.15-.264-.214-.33 5.065-.33 26.225v26.492l3.108-2.262c1.71-1.245 9.863-7.169 18.117-13.165z"
        ></path>
      </g>
    </svg>
  );
}

export default TeleOnlineIcon;
